import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_USER_URL = process.env.REACT_APP_API_BASE_USER_URL;

const apiService = {

  login: async (userName, password) => {
    const url = `${BASE_URL}/signin`;

    const response = await axios.post(url, {
      userName,
      password,
    });

    if (response.status === 200 && response.data.payload.success) {
      return response.data.payload;
    } else {
      throw new Error(response.data.message || 'Login failed');
    }
  },
      clearAuthToken: () => {
    delete axios.defaults.headers.common['Authorization'];
  },

// Archive API calls
syncArchive: async (empId, accessToken) => {
  try {
    const url = `${BASE_URL}/update-archive`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.get(url);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to sync archive');
    }
  } catch (error) {
    console.error('Error syncing archive:', error);
    throw error;
  }
},

  // ====== RJ Posters API calls ===========
createRjPoster: async (empId, accessToken, rjData) => {
  try {
    const url = `${BASE_URL}/create-rjPosters`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, rjData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create RJ poster');
    }
  } catch (error) {
    console.error('Error creating RJ poster:', error);
    throw error;
  }
},
updateRjPoster: async (empId, accessToken, rjData) => {
  try {
    const url = `${BASE_URL}/update-rj-poster`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, rjData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to update RJ poster');
    }
  } catch (error) {
    console.error('Error updating RJ poster:', error);
    throw error;
  }
},

deleteRjPoster: async (empId, accessToken, rjPosterId) => {
  try {
    const url = `${BASE_URL}/delete-rj-poster`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.delete(url, {
      data: {
        id: empId,
        rjPosterId: rjPosterId
      }
    });
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to delete RJ poster');
    }
  } catch (error) {
    console.error('Error deleting RJ poster:', error);
    throw error;
  }
},
// Ads API calls
createAd: async (empId, accessToken, adData) => {
  try {
    const url = `${BASE_URL}/create-ads`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, adData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create ad');
    }
  } catch (error) {
    console.error('Error creating ad:', error);
    throw error;
  }
},

// Update Ad
updateAd: async (empId, accessToken, adData) => {
  try {
    const url = `${BASE_URL}/update-ad`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, adData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to update ad');
    }
  } catch (error) {
    console.error('Error updating ad:', error);
    throw error;
  }
},

// Delete Ad
deleteAd: async (empId, accessToken, adId) => {
  try {
    const url = `${BASE_URL}/delete-ad`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.delete(url, {
      data: {
        id: empId,
        adId: adId
      }
    });
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to delete ad');
    }
  } catch (error) {
    console.error('Error deleting ad:', error);
    throw error;
  }
},
  // ===== News API calls======
  fetchNewsList: async (empId, accessToken) => {
    try {
      const url = `${BASE_URL}/${empId}/news-list`;
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      console.log("Access token being used:", accessToken);
      const response = await axios.get(url);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('Failed to fetch news');
      }
    } catch (error) {
      console.error('Error fetching news list:', error);
      throw error;
    }
  },

  updateNewsStatus: async (empId, accessToken, news) => {
    try {
      const url = `${BASE_URL}/update-news/${empId}`;
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

      const response = await axios.put(url, news);

      if (response.status === 200) {
        const updatedStatus = news.status === 'active' ? 'inactive' : 'active';
        const updatedNews = { ...news, status: updatedStatus };
        return updatedNews;
      } else {
        throw new Error('Failed to update news');
      }
    } catch (error) {
      console.error('Error updating news:', error);
      throw error;
    }
  },

  createNews: async (empId, accessToken, newsData) => {
    try {
      const url = `${BASE_URL}/create-news`;
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      const response = await axios.post(url, newsData);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('Failed to create news');
      }
    } catch (error) {
      console.error('Error creating news:', error);
      throw error;
    }
  },
  // events create call 
createEvent: async (empId, accessToken, eventData) => {
  try {
    const url = `${BASE_URL}/create-events`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, eventData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create event');
    }
  } catch (error) {
    console.error('Error creating event:', error);
    throw error;
  }
},
// Add this to your existing apiService object
createJaataraEvent: async (empId, accessToken, eventData) => {
  try {
    const url = `${BASE_URL}/create-jaataraEvents`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, eventData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create jaatara event');
    }
  } catch (error) {
    console.error('Error creating jaatara event:', error);
    throw error;
  }
},
// panorama call
createPanorama: async (empId, accessToken, panoramaData) => {
  try {
    const url = `${BASE_URL}/create-panorama`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, panoramaData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create panorama');
    }
  } catch (error) {
    console.error('Error creating panorama:', error);
    throw error;
  }
},
  // create podcast call 
createPodcast: async (empId, accessToken, podcastData) => {
  try {
    const url = `${BASE_URL}/create-podcast`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, podcastData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create podcast');
    }
  } catch (error) {
    console.error('Error creating podcast:', error);
    throw error;
  }
},
// press call
createPress: async (empId, accessToken, pressData) => {
  try {
    const url = `${BASE_URL}/create-press`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, pressData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create press');
    }
  } catch (error) {
    console.error('Error creating press:', error);
    throw error;
  }
},
// createStream 
createStream: async (empId, accessToken, streamData) => {
  try {
    const url = `${BASE_URL}/create-stream`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, streamData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create stream');
    }
  } catch (error) {
    console.error('Error creating stream:', error);
    throw error;
  }
},
// contest 
createContest: async (empId, accessToken, contestData) => {
  try {
    const url = `${BASE_URL}/create-contest`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, contestData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create contest');
    }
  } catch (error) {
    console.error('Error creating contest:', error);
    throw error;
  }
},
// magzine call create
createMagazine: async (empId, accessToken, magazineData) => {
  try {
    const url = `${BASE_URL}/create-magazine`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, magazineData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create magazine');
    }
  } catch (error) {
    console.error('Error creating magazine:', error);
    throw error;
  }
},
// category call 
createCategory: async (empId, accessToken, categoryData) => {
  try {
    const url = `${BASE_URL}/create-category`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, categoryData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create category');
    }
  } catch (error) {
    console.error('Error creating category:', error);
    throw error;
  }
},
// =========== sponsor api calls ==============
// create sponsor APi call 
createSponsor: async (empId, accessToken, sponsorData) => {
  try {
    const url = `${BASE_URL}/create-sponsor`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, sponsorData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create sponsor');
    }
  } catch (error) {
    console.error('Error creating sponsor:', error);
    throw error;
  }
},
// Update Sponsor
updateSponsor: async (empId, accessToken, sponsorData) => {
  try {
    const url = `${BASE_URL}/update-sponsor`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.put(url, sponsorData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to update sponsor');
    }
  } catch (error) {
    console.error('Error updating sponsor:', error);
    throw error;
  }
},

// Delete Sponsor
deleteSponsor: async (empId, accessToken, sponsorId) => {
  try {
    const url = `${BASE_URL}/delete-sponsor`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.delete(url, {
      data: {
        id: empId,
        sponsorId: sponsorId
      }
    });
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to delete sponsor');
    }
  } catch (error) {
    console.error('Error deleting sponsor:', error);
    throw error;
  }
},
// Fetch sponsors list API
  fetchSponsorsList: async (empId, accessToken) => {
    try {
      const url = `${BASE_URL}/${empId}/sponsor-list`;
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      const response = await axios.get(url);

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('Failed to fetch sponsors list');
      }
    } catch (error) {
      console.error('Error fetching sponsors list:', error);
      throw error;
    }
  },

  // ======Program API calls ===========

  // In api-service.js - ADD ONLY THESE:

// Create Program
createProgram: async (empId, accessToken, programData) => {
  try {
    const url = `${BASE_URL}/create-prg`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    const response = await axios.post(url, programData);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create program');
    }
  } catch (error) {
    console.error('Error creating program:', error);
    throw error;
  }
},

// Update Program  
updateProgram: async (empId, accessToken, programData) => {
  try {
    const url = `${BASE_URL}/update-prg`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    const response = await axios.post(url, programData);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to update program');
    }
  } catch (error) {
    console.error('Error updating program:', error);
    throw error;
  }
},

// Delete Program
deleteProgram: async (empId, accessToken, programId) => {
  try {
    const url = `${BASE_URL}/delete-program`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.delete(url, {
      data: {
        id: empId,
        programId: programId
      }
    });
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to delete program');
    }
  } catch (error) {
    console.error('Error deleting program:', error);
    throw error;
  }
},

  // ======Movies API calls ==============
  fetchMoviesList: async (empId, accessToken) => {
    const url = `${BASE_URL}/${empId}/movies-list`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to fetch movies');
    }
  },

  updateMovieStatus: async (empId, accessToken, movie) => {
    const url = `${BASE_URL}/update-movies/${empId}`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    const response = await axios.put(url, movie);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to update movie');
    }
  },

  createMovie: async (empId, accessToken, movieData) => {
  try {
    const url = `${BASE_URL}/create-movies`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
    const response = await axios.post(url, movieData);
    
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to create movie');
    }
  } catch (error) {
    console.error('Error creating movie:', error);
    throw error;
  }
},


// Add this inside your apiService object

fetchEventsList: async (empId, accessToken) => {
  try {
    const url = `${BASE_URL}/${empId}/events-list`;
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    const response = await axios.get(url);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to fetch events list');
    }
  } catch (error) {
    console.error('Error fetching events list:', error);
    throw error;
  }
},


// Update Event API call
updateEvent: async (empId, accessToken, eventData) => {
  try {
    const url = `${BASE_URL}/update-events`; // Use your actual endpoint
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

    // eventData should contain PK, SK, all editable fields
    const response = await axios.put(url, eventData);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to update event');
    }
  } catch (error) {
    console.error('Error updating event:', error);
    throw error;
  }
},

// Delete Event API call
deleteEvent: async (empId, accessToken, eventId) => {
  try {
    const url = `${BASE_URL}/delete-events`; // Use your actual endpoint
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

    // Pass all needed identifiers for a precise delete
    const response = await axios.delete(url, {
      data: {
        id: empId,
        eventId: eventId // likely PK or eventId; adjust to match backend
         // secondary key from event object (if needed)
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error('Failed to delete event');
    }
  } catch (error) {
    console.error('Error deleting event:', error);
    throw error;
  }
},

};


export default apiService;